import { createFileRoute } from "@tanstack/react-router";
import CropZones from "@/components/field/setup/CropZones";

export const Route = createFileRoute(
    "/dashboard/fields/$fieldId/setup/crop-zones/",
)({
    component: CropZonesPane,
});

function CropZonesPane() {
    return <CropZones />;
}
